import React, { createContext, useContext } from 'react';

import { DatabaseClient, getDatabaseClient } from './DatabaseClient';

const DatabaseContext = createContext<DatabaseClient | null>(null);

type DatabaseProviderProps = {
  client: DatabaseClient | null;
  children: React.ReactNode;
};

export const DatabaseProvider: React.FC<DatabaseProviderProps> = ({ client, children }) => (
  <DatabaseContext.Provider value={client}>{children}</DatabaseContext.Provider>
);

/** React context accessor; falls back to the active singleton when used outside the provider tree. */
export function useDatabaseClient(): DatabaseClient | null {
  const fromContext = useContext(DatabaseContext);
  if (fromContext) {
    return fromContext;
  }
  return getDatabaseClient();
}

export default DatabaseContext;
